/**
 * Comparação entre duas versões do manual ("v6 → v7 · 2 passos alterados"):
 * o que mudou em cada passo, pela chave estável, não pela posição.
 */
import { CAMPOS_DO_CABECALHO, CAMPOS_DO_PASSO, ROTULO_DO_CAMPO } from "./editor";

const igual = (a, b) => JSON.stringify(a ?? "") === JSON.stringify(b ?? "");

function camposDiferentes(antes, depois, campos) {
  return campos
    .filter((campo) => !igual(antes?.[campo], depois?.[campo]))
    .map((campo) => ({ campo, rotulo: ROTULO_DO_CAMPO[campo] || campo, antes: antes?.[campo] || "", depois: depois?.[campo] || "" }));
}

function tituloDoPasso(passo) {
  return passo.titulo_curto || (passo.texto || "").slice(0, 60);
}

export function compararVersoes(anterior, atual) {
  const antes = new Map((anterior?.passos || []).map((p, i) => [p.chave, { ...p, numero: i + 1 }]));
  const depois = new Map((atual?.passos || []).map((p, i) => [p.chave, { ...p, numero: i + 1 }]));
  const passos = [];
  depois.forEach((passo, chave) => {
    const velho = antes.get(chave);
    if (!velho) {
      passos.push({ tipo: "novo", numero: passo.numero, titulo: tituloDoPasso(passo), campos: [] });
      return;
    }
    const campos = camposDiferentes(velho, passo, [...CAMPOS_DO_PASSO, "referencia"]);
    if (campos.length) passos.push({ tipo: "alterado", numero: passo.numero, titulo: tituloDoPasso(passo), campos });
  });
  antes.forEach((passo, chave) => {
    if (!depois.has(chave)) passos.push({ tipo: "removido", numero: passo.numero, titulo: tituloDoPasso(passo), campos: [] });
  });
  passos.sort((a, b) => a.numero - b.numero);

  const comuns = (mapa, outro) => [...mapa.keys()].filter((c) => outro.has(c));
  return {
    campos: camposDiferentes(anterior, atual, ["titulo", ...CAMPOS_DO_CABECALHO]),
    passos,
    reordenado: !igual(comuns(antes, depois), comuns(depois, antes)),
    secoes: !igual(anterior?.secoes, atual?.secoes),
  };
}

export function totalDeMudancas(comparacao) {
  return comparacao.campos.length + comparacao.passos.length + (comparacao.reordenado ? 1 : 0) + (comparacao.secoes ? 1 : 0);
}
